import React, {Fragment} from "react";
import ChatsContent from "./ChatsContent";
import {Dropdown} from "react-bootstrap";
import ChatBlankComment from "./ChatBlankComment";

class ChatsPrivateContent extends ChatsContent {

    blankArea = () => {
        return (
            <ChatBlankComment/>
        )
    }

    chatDropdownMenuContent = () => {
        return (
            <Fragment>
                <Dropdown.Item>Clear Chats</Dropdown.Item>
                <Dropdown.Item>View Contact</Dropdown.Item>
            </Fragment>
        )
    }

    getMemberInfo = () => {
        return (
            <Fragment>
                <img src={this.props.data.participants[0].avatar} alt="Nathan Warren"/>
                <div className="d-flex flex-column">
                    <h3>{this.props.data.name}</h3>
                    <div className="d-flex flex-wrap">
                        <p>{this.props.data.info}</p>
                        <a href="#">See More Info</a>
                    </div>
                </div>
            </Fragment>
        );
    }
};

export default ChatsPrivateContent;
